<template>
  <div>
    <navBack title="基本信息"></navBack>
    <div class="userView">
      <div class="userdetail_title">
        <p>基本信息</p>
        <span @click="changeInfo">编辑</span>
      </div>
      <div class="userdetail_head" v-show="changeShow">
        <p>姓名：{{ userInfo.real_name }}</p>
        <p class="userdetail_head__p">
          <span
            >{{ userInfo.sex }}&nbsp;&nbsp;|&nbsp;&nbsp;{{
              userInfo.education_label
            }}</span
          >
          <span>手机号：{{ userInfo.cellphone }}</span>
          <span>邮箱：{{ userInfo.email }}</span>
        </p>
        <p class="userdetail_head__p">
          <span>身份证号：{{ userInfo.id_card }}</span>
          <span>出生日期：{{ userInfo.birth }}</span>
          <span>单位：{{ userInfo.company_name }}</span>
        </p>
        <p class="userdetail_head__p">
          <span>单位类型：{{ userInfo.company_type_label }}</span>
          <span>职务：{{ userInfo.position }}</span>
          <span>服务主体：{{ userInfo.service_main_label }}</span>
        </p>
      </div>
      <!-- 编辑 -->
      <div class="userdetail_head" v-if="!changeShow">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名" prop="real_name">
            <el-input v-model="ruleForm.real_name"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="education">
            <el-select v-model="ruleForm.education" placeholder="请选择学历">
              <el-option
                v-for="item in educationList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>

          <el-form-item label="单位" prop="company_name">
            <el-input v-model="ruleForm.company_name"></el-input>
          </el-form-item>
          <el-form-item label="单位类型" prop="company_type">
            <el-select
              v-model="ruleForm.company_type"
              placeholder="请选择单位类型"
            >
              <el-option
                v-for="item in companyType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职务" prop="position">
            <el-input v-model="ruleForm.position"></el-input>
          </el-form-item>

          <el-form-item label="服务主体" prop="service_main">
            <el-select
              v-model="ruleForm.service_main"
              placeholder="请选择服务主体"
            >
              <el-option
                v-for="item in serviceMain"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件照" prop="photo">
            <el-upload
              class="avatar-uploader"
              accept=".png,.jpg,.jpeg"
              :headers="uploadHeaders"
              :action="upLoadUrl"
              :data="uploadData"
              :on-success="handleSuccess"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="imageUrl"
                style="width: 100%"
                :src="imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"> </i>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png/jpeg文件，且不超过2MB</div> -->
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交审核</el-button
            >
            <el-button @click="changeShow = true">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import navBack from "../../components/navBack.vue";
import { upLoadUrl, uploadHeaders, uploadData } from "@/utils/uploadConfig.js";
import {
  getVipUser,
  getInfoStatus,
  saveInfo,
  getAliOssAddress,
  updatePhone,
} from "../../api/moudles/user.js";
export default {
  data() {
    return {
      upLoadUrl,
      uploadHeaders,
      uploadData,
      imageUrl: "",
      changeShow: true,
      userInfo: {},
      editStatus: 0,
      originForm: {},
      ruleForm: {
        real_name: "",
        email: "",
        education: "",
        company_name: "",
        company_type: "",
        position: "",
        service_main: "",
        photo: "",
      },
      rules: {
        real_name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        education: [
          {
            required: true,
            message: "请选择学历",
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "change",
          },
        ],
        company_name: [
          {
            required: true,
            message: "请输入单位名称",
            trigger: "change",
          },
        ],
        company_type: [
          {
            required: true,
            message: "请选择单位类型",
            trigger: "blur",
          },
        ],
        position: [
          {
            required: true,
            message: "请输入职位",
            trigger: "blur",
          },
        ],
        service_main: [
          {
            required: true,
            message: "请选择服务主体",
            trigger: "blur",
          },
        ],
        photo: [
          {
            required: true,
            message: "请上传证件照",
            trigger: "blur",
          },
        ],
      },
      // 学历
      educationList: [
        {
          label: "博士",
          value: 1,
        },
        {
          label: "硕士",
          value: 2,
        },
        {
          label: "本科",
          value: 3,
        },
        {
          label: "大专",
          value: 4,
        },
        {
          label: "高中",
          value: 5,
        },
        {
          label: "中专/中技",
          value: 6,
        },
        {
          label: "初中及以下",
          value: 7,
        },
      ],
      // 单位性质
      companyType: [
        {
          label: "中央企业",
          value: 1,
        },
        {
          label: "地方国企",
          value: 2,
        },
        {
          label: "事业单位",
          value: 3,
        },
        {
          label: "民营企业",
          value: 4,
        },
        {
          label: "自由职业",
          value: 5,
        },
        {
          label: "在校学生",
          value: 6,
        },
        {
          label: "其他",
          value: 7,
        },
      ],
      // 服务主体
      serviceMain: [
        {
          label: "法律服务工作委员会",
          value: 1,
        },
        {
          label: "钢木建筑分会",
          value: 2,
        },
        {
          label: "工程技术与BIM应用分会",
          value: 3,
        },
        {
          label: "工程项目管理与建造师分会",
          value: 4,
        },
        {
          label: "古建园林与环境工程分会",
          value: 5,
        },
        {
          label: "航天工程建设分会",
          value: 6,
        },
        {
          label: "核工业建设分会",
          value: 7,
        },
        {
          label: "混凝土分会",
          value: 8,
        },
        {
          label: "建筑安全与机械分会",
          value: 9,
        },
        {
          label: "建筑防水分会",
          value: 10,
        },
        {
          label: "建筑供应链与劳务管理分会",
          value: 11,
        },
        {
          label: "绿色建造与智能建筑分会",
          value: 12,
        },
        {
          label: "深基础与地下空间工程分会",
          value: 13,
        },
        {
          label: "石化建设分会",
          value: 14,
        },
        {
          label: "质量管理与监督检测分会",
          value: 15,
        },
        {
          label: "中小企业分会",
          value: 16,
        },
      ],
    };
  },
  components: {
    navBack,
  },
  created() {
    this.getVipUser();
    this.getInfoStatus();
    this.getAliOss();
  },
  methods: {
    // 获取阿里云地址
    async getAliOss() {
      await getAliOssAddress({
        success: (res) => {
          localStorage.setItem("ossPath", res.data);
        },
      });
    },
    // 提交前验证
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!");
      }
      return isLt2M;
    },
    // 覆盖原生提交
    handleSuccess(file) {
      this.$message({
        message: "上传成功",
        type: "success",
      });
      this.imageUrl = file.data;
      this.ruleForm.photo = file.data;
    },
    // 提交验证
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const newArr = [];
          Object.keys(this.ruleForm).forEach((key) => {
            if (this.ruleForm[key] != this.originForm[key]) {
              const newObj = {};
              newObj.type = key;
              newObj.msg = this.ruleForm[key];
              newArr.push(newObj);
            }
          });
          if (newArr.length) {
            this.saveInfo(newArr);
          } else {
            this.$message.error("您还没有修改任何信息！");
          }
        } else {
          return false;
        }
      });
    },
    // 获取个人信息待审核状态
    async getInfoStatus() {
      await getInfoStatus({
        success: (res) => {
          this.editStatus = res.data.info_status;
        },
      });
    },
    // 打开编辑按钮
    changeInfo() {
      // 编辑按钮打开之前 需要判断有无正在等待审核的
      if (this.editStatus == 1) {
        this.$message.warning("有待审核中的变更信息");
        return;
      }
      this.changeShow = false;
    },
    // 获取用户信息
    async getVipUser() {
      await getVipUser({
        success: (res) => {
          this.userInfo = res.data;
          const {
            real_name,
            email,
            education,
            company_name,
            company_type,
            position,
            service_main,
            photo,
          } = res.data;

          // 如果没有手机号,提示弹窗完善(强制)
          if (!res.data.cellphone) {
            this.$prompt("请完善手机号码（用于接收短信通告）", "提示", {
              confirmButtonText: "确定",
              confirmButtonClass: "newConfirm",
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
              inputPattern: /^1\d{10}$/,
              inputErrorMessage: "手机号格式不正确",
            }).then(({ value }) => {
              updatePhone({
                data: {
                  cellphone: value,
                },
                success: (res) => {
                  if (res.code != 200) {
                    this.$message.error(res.msg);
                    this.getVipUser();
                  } else {
                    this.$message({
                      type: "success",
                      message: res.msg,
                    });
                    this.getVipUser();
                  }
                },
              });
            });
          }
          if (res.data.flow_status_name == "冻结") {
            // 账号被冻结
            this.$confirm("当前账号已被冻结，无法使用", "提示", {
              confirmButtonText: "退出登录",
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
              type: "warning",
              center: true,
            }).then(() => {
              this.isLogin = false;
              this.userName = "会员";
              this.userHead = "";
              this.$store.commit("user/RESET_INFO");
              localStorage.removeItem("token");
              localStorage.removeItem("userName");
              localStorage.removeItem("userPhoto");
              setTimeout(() => {
                this.$message({
                  message: "退出成功，请重新登录!",
                  type: "success",
                });
                this.$router.replace("/login");
              }, 500);
              // 需要登录
            });
          }

          this.originForm = {
            real_name,
            email,
            education,
            company_name,
            company_type,
            position,
            service_main,
            photo,
          };
          this.ruleForm = {
            real_name,
            email,
            education,
            company_name,
            company_type,
            position,
            photo,
          };
          this.imageUrl = photo;
          if (service_main) {
            this.ruleForm.service_main = service_main;
          } else {
            this.ruleForm.service_main = 4;
          }
        },
      });
    },
    // 变更信息
    async saveInfo(params) {
      await saveInfo({
        data: {
          info: params,
        },
        success: (res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$store.dispatch("user/GET_USERINFO");
            this.getInfoStatus();
            setTimeout(() => {
              this.changeShow = true;
            }, 1500);
          } else {
            this.$message.error(res.msg);
          }
        },
      });
    },
  },
};
</script>

<style scoped>
.userView {
  min-height: 650px;
  background-color: #fff;
  margin-bottom: 20px;
  border: 1px solid #fff;
}

.userdetail_title {
  display: flex;
  justify-content: space-between;
  height: 60px;
  font-weight: 500;
  line-height: 60px;
  padding: 0 20px;
  border-bottom: 1px solid #f2f2f2;
}

.userdetail_title p {
  font-size: 22px;
}

.userdetail_title span {
  cursor: pointer;
}

.userdetail_head {
  padding: 20px 20px 60px 20px;
}

.userdetail_head p {
  margin: 10px 0;
}

.userdetail_head p > span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.userdetail_head_form {
  width: 100%;
  display: flex;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #dcdfe6;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.userdetail_body {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.userdetail_head__p {
  display: flex;
  justify-content: space-between;
  flex-flow: column;
}

.userdetail_body__view {
  width: 33%;
}

.userdetail_body__view > span {
  margin-top: 12px;
  display: inline-block;
}

.userdetail_body__view p {
  min-height: 20px;
}

.userdetail_body__view_view {
  display: flex;
  width: 100%;
  justify-content: flex-end;
  height: 40px;
}

.userdetail_body__pspan {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.userdetail_body__view_view p {
  margin-left: 30px;
  font-size: 15px;
}
</style>
